// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","container":"styles_container__EtMAz","link":"styles_link__wKFwb","selected":"styles_selected__grbwy"};